import React from 'react'
import {
  Chip,
  Avatar,
  Tooltip
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DescriptionIcon from "@mui/icons-material/Description";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { faBarcode, faBox } from "@fortawesome/free-solid-svg-icons";
import { EnumStatusShipment } from "../../shared/Enumerables";

const IconShipmentStatus = ({ idStatus }) => (
  <>
    {
      idStatus === EnumStatusShipment.Recibido ? (
        <>
          <Avatar
            sx={{
              width: 50,
              height: 50,
              bgcolor: "recibido.main",
              marginBottom: "5px",
            }}
            variant="rounded"
          >
            <FontAwesomeIcon icon={faBarcode} />
          </Avatar>
          <Tooltip title="Recibido en instalaciones" placement="top">
            <Chip
              label="Recibido en instalaciones"
              sx={{ bgcolor: "recibido.main", color: "#fff" }}
            />        
          </Tooltip>
        </>
      ) : idStatus === EnumStatusShipment.Documentado ? (
        <>
          <Avatar
            sx={{
              width: 50,
              height: 50,
              bgcolor: "#ed6c02",
              marginBottom: "5px",
            }}
            variant="rounded"
          >
            <DescriptionIcon />
          </Avatar>
          <Tooltip title="Documentado" placement="top">
            <Chip label="Documentado" color="warning" />          
          </Tooltip>
        </>
      ) : idStatus === EnumStatusShipment.En_Transito ? (
        <>
          <Avatar
            sx={{
              width: 50,
              height: 50,
              bgcolor: "primary.main",
              marginBottom: "5px",
            }}
            variant="rounded"
          >
            <LocalShippingIcon />
          </Avatar>
          <Tooltip title="En tránsito" placement="top">
            <Chip label="En tránsito" color="primary" />          
          </Tooltip>
        </>
      ) : idStatus === EnumStatusShipment.Entregado ? (
        <>
          <Avatar
            sx={{
              width: 50,
              height: 50,
              bgcolor: "success.main",
              marginBottom: "5px",
            }}
            variant="rounded"
          >
            <FontAwesomeIcon icon={faBox} />
          </Avatar>
          <Tooltip title="Entregado" placement="top">
            <Chip label="Entregado" color="success" />          
          </Tooltip>
        </>
      ) : idStatus === EnumStatusShipment.Creado ? (
        <>
        <Avatar
            sx={{
              width: 50,
              height: 50,
              bgcolor: "recibido.main",
              marginBottom: "5px",
            }}
            variant="rounded"
          >
            <FontAwesomeIcon icon={faBarcode} />
          </Avatar>
          <Tooltip title="Creado" placement="top">
            <Chip
              label="Creado"
              sx={{ bgcolor: "recibido.main", color: "#fff" }}
            />        
          </Tooltip>
        </>
      ) :  (
        <></>
      )
    }
  </>
);

export default IconShipmentStatus;
